// Extra checks for forms that contain the off-screen .form-website field.
// Runs in the capture phase on document, so it decides before the theme's and
// Shopify's CAPTCHA submit handlers see the event.
(() => {
  const loadedAt = Date.now();

  const showRetryMessage = (form, extraField) => {
    let message = form.querySelector(".form__retry-notice");
    if (!message) {
      message = document.createElement("p");
      message.className = "form__message form__message--error body-small form__retry-notice";
      message.setAttribute("role", "alert");
      form.appendChild(message);
    }
    message.textContent = extraField.dataset.retryMessage;
  };

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      const extraField = form.querySelector(".form-website");
      if (!extraField) return;

      const filled = extraField.querySelector("input").value.trim() !== "";
      const minSeconds = Number(extraField.dataset.minSeconds) || 0;
      const tooFast = Date.now() - loadedAt < minSeconds * 1000;
      if (!filled && !tooFast) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      // A filled field means a bot: fail silently. A fast submit may be a human, so explain it.
      if (!filled) showRetryMessage(form, extraField);
    },
    true
  );
})();
